import { render, staticRenderFns } from "./TermsAccepted.vue?vue&type=template&id=111b1f45"
import script from "./TermsAccepted.vue?vue&type=script&lang=js"
export * from "./TermsAccepted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports